import React, { Component } from 'react';
import { connect } from 'react-redux';
import determinarPaginaAtual from '../../../actions/resumo-financeiro/determinarPaginaAtualResumoFinanceiro';

import BotoesPaginacao from '../../comum/BotoesPaginacao';

export class SetasPaginacaoResumoFinanceiro extends Component {
  render () {
    if (this.props.resumoFinanceiro.length === 0) {
      return '';
    }

    return <BotoesPaginacao
      numeroElementos={this.props.resumoFinanceiro.length}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtual}/>;
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualResumoFinanceiro,
    resumoFinanceiro: state.resumoFinanceiro.resumos,
    registrosPorPagina: state.registrosPorPaginaResumoFinanceiro
  };
}

export default connect(mapStateToProps, { determinarPaginaAtual })(SetasPaginacaoResumoFinanceiro);
